import InfoCompleteDialog from './InfoCompleteDialog';
import './style/info-complete-dialog.less';

export default InfoCompleteDialog;
